import React, { Component } from 'react'
import s from './LoadingLinear.scss'
import cn from 'classnames'

export default class extends Component {
  render() {
    const { type, className, style } = this.props
    return (
      <div className={cn(s.progress, className)} style={style}>
        <div className={type == 'determinate' ? s.determinate : s.indeterminate} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Loading/LoadingLinear/LoadingLinear.jsx